/**
 * Tracks the seat pending in the passenger modal (WS selected, not confirmed yet).
 * Pure helper for BookingBus + unit tests.
 *
 * No HTTP happens while a seat is pending: the single POST /block runs on
 * Continuar, so the tracker only needs the seat identity and the WS flag.
 */
export function createSeatLockTracker () {
  let wsSelected = false
  let seat = null

  return {
    setSeat (next) {
      seat = next
    },
    getSeat () {
      return seat
    },
    /** @param {string} seatId */
    isTracking (seatId) {
      if (seatId == null || seat == null) return false
      return String(seat.seatId) === String(seatId)
    },
    markWsSelected () {
      wsSelected = true
    },
    markWsUnselected () {
      wsSelected = false
    },
    isWsSelected () {
      return wsSelected
    },
    reset () {
      wsSelected = false
      seat = null
    },
  }
}
